<template>
  <section
    class="component-ea825d9c"
    resmed-component-name="featured-online-retailers"
  >
    <div class="component">
      <nav class="py-4">
        <div class="container px-xs-sm-2">
          <div class="row">
            <div class="col-md-4 pb-2 pb-md-0 d-flex justify-content-center">
              <a
                v-on:click.capture="
                  $root.datalayer.push({
                    event: 'onlineStoreLocatorClick',
                    action: 'View all online CPAP stores',
                    location: undefined,
                  })
                "
                href="/sleep-apnea/authorized-online-stores-full-list/"
                class="cpap-stores"
                >View all online <br class="d-none d-md-block d-lg-none" />CPAP
                stores</a
              >
            </div>
            <div class="col-md-4 py-3 py-md-0 d-flex justify-content-center">
              <a
                v-on:click.capture="
                  $root.datalayer.push({
                    event: 'onlineStoreLocatorClick',
                    action: 'Go to Offline Dealer Locator',
                    location: undefined,
                  })
                "
                href="/sleep-apnea/find-cpap-supplies-near-me/"
                class="find-store-near-you"
                >Find CPAP <br class="d-none d-md-block d-lg-none" />store near
                you</a
              >
            </div>
            <div class="col-md-4 pt-2 pt-md-0 d-flex justify-content-center">
              <a
                href="#"
                class="filter-products-offered"
                v-bind:class="{ 'filters-is-active': filters.applied.length }"
                v-on:click.prevent="filters.active = true"
                >{{ $getTranslation("Filter by", $route.params.region) }} <br class="d-none d-md-block d-lg-none" />products
                offered</a
              >

              <div v-if="filters.active" class="filters">
                <header>
                  <h4>Filters</h4>
                  <a href="#" v-on:click.prevent="filters.active = false"></a>
                </header>
                <ul>
                  <li
                    v-for="filter in filters.values"
                    v-bind:class="{
                      'is-active': filters.applied.includes(filter),
                    }"
                  >
                    <a
                      v-on:click.prevent="
                        (!filters.applied.includes(filter) &&
                          $set(filters.applied, 0, filter)) ||
                          (filters.applied = [])
                      "
                      href="#"
                      >{{ filter }}</a
                    >
                  </li>
                </ul>
                <div class="apply" v-if="filters.applied.length">
                  <a
                    href="#"
                    v-on:click.prevent="filters.active = false"
                    class="btn cta-pill filled-red"
                    >Apply</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <div class="container px-xs-sm-2 pt-5 pb-6">
        <h3>Featured online retailers</h3>
        <!-- <p class="d-block d-md-none pt-2 pb-1 applied-filter" v-if="filters.applied.length"><strong>Applied filter: </strong><span v-on:click="filters.applied.pop()">{{ filters.applied[0] }}</span></p> -->
        <div class="items mb-5">
          <div class="item" v-for="item in results">
            <a
              v-on:click.capture="
                $root.datalayer.push({
                  event: 'onlineStoreLocatorClick',
                  action: 'Featured - Visit Online Store',
                  location: item.name,
                })
              "
              target="_blank"
              v-bind:href="href(item)"
            >
              <figure>
                <img class="img-fluid" v-bind:src="item['logo-color']" alt="" />
              </figure>
              <div class="cta">
                <a
                  target="_blank"
                  v-bind:href="href(item)"
                  class="btn cta-plain text-red icon right-arrow"
                  >{{ cta }}</a
                >
              </div>
            </a>
          </div>
        </div>
        <div class="cta text-center">
          <a
            v-on:click="
              $root.datalayer.push({
                event: 'onlineStoreLocatorClick',
                action: 'View full list of online retailers',
                location: undefined,
              })
            "
            href="/sleep-apnea/authorized-online-stores-full-list/"
            class="btn cta-pill filled-red icon right-arrow"
            >View full list of online retailers</a
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-ea825d9c", // featured-online-retailers
  props: ["acf"],
  data() {
    return {
      items: [],
      filters: {
        active: false,
        values: [
          "CPAP machine",
          "CPAP mask",
          "AirMini travel CPAP",
          "AirTouch memory foam mask",
        ],
        applied: [],
        map: {
          "CPAP machine": "cpap-machine",
          "CPAP mask": "cpap-mask",
          "AirMini travel CPAP": "airmini",
          "AirTouch memory foam mask": "airtouch",
        },
      },
    };
  },
  computed: {
    cta() {
      switch (this.filters.applied[0]) {
        case "CPAP machine":
          return "Buy CPAP machine";
          break;
        case "CPAP mask":
          return "Buy CPAP mask";
          break;
        case "AirMini travel CPAP":
          return "Buy AirMini CPAP";
          break;
        case "AirTouch memory foam mask":
          return "Buy AirTouch mask";
          break;
        default:
          return "Buy online";
      }
    },
    results() {
      let arr = this.items.filter((item) => {
        if (!this.filters.applied.length) {
          return true;
        }

        // returns false if empty, string otherwise
        return item.filters[this.filters.map[this.filters.applied]];
      });

      return arr;
    },
  },
  watch: {
    "filters.active"(val) {
      if (!val) {
        this.$root.datalayer.push({
          event: "onlineStoreLocatorClick",
          action: "Filter Applied",
          filter: this.filters.applied[0],
        });
      }

      val &&
        this.results.sort(() => {
          return 0.5 - Math.random();
        });
    },
  },
  methods: {
    test() {
      console.log("var1, var2");
    },
    href(item) {
      if (!this.filters.applied.length) {
        return item.website;
      } else {
        return item.filters[this.filters.map[this.filters.applied[0]]];
      }
    },
  },
  created() {
    // shuffle, and limit to 9
    this.items = this.acf.items
      .sort(() => {
        return 0.5 - Math.random();
      })
      .slice(0, 9);

    // pre-selected filter
    // example: #filter=cpap_machine
    let hash = window.location.hash.substring(1).replace("filter=", ""),
      arr = [
        "cpap_machine",
        "cpap_mask",
        "airmini_travel_cpap",
        "airtouch_mask",
      ]; // client request. do not change vals.

    let map = {
      cpap_machine: "CPAP machine",
      cpap_mask: "CPAP mask",
      airmini_travel_cpap: "AirMini travel CPAP",
      airtouch_mask: "AirTouch memory foam mask",
    };

    if (arr.includes(hash)) {
      this.filters.applied[0] = map[hash]; // apply filter
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-ea825d9c {
  // -->
}

.component {
  %close-x {
    display: block;
    width: 1.25rem;
    height: 1.25rem;
    background-repeat: no-repeat;
    background-size: 1rem 1rem;
    background-position: center center;
    background-image: url(#{$assets}/images/icon-close-white.svg);
    padding: 0;
  }

  h3 {
    margin-bottom: 0.675rem;
  }

  nav {
    background-color: #f1f4f7;

    .container {
      max-width: 920px;
    }

    [class*="col-"] {
      text-align: center;

      @media (min-width: 768px) and (max-width: 991px) {
        text-align: left;
        padding-right: 2rem;
        padding-left: 2rem;
      }
    }

    a {
      color: $cc-resmed-black;
      display: inline-block;
      padding-left: 2rem;
      background-position: left center;
      background-repeat: no-repeat;
      transition: color 0.5s;

      @media (min-width: 768px) and (max-width: 991px) {
        padding-left: 2.5rem;
      }

      &:hover {
        color: $cc-resmed-pulse-blue;
      }

      &.filters-is-active {
        color: $cc-resmed-pulse-blue;
      }
    }

    .cpap-stores {
      background-image: url(#{$assets}/images/icon-shopping-cart-black.svg);
    }
    .find-store-near-you {
      background-image: url(#{$assets}/images/icon-compass-black.svg);
    }
    .filter-products-offered {
      background-image: url(#{$assets}/images/icon-filter-lines-black.svg);

      &.filters-is-active {
        position: relative;
        background-image: url(#{$assets}/images/icon-filter-lines-blue.svg);

        &:after {
          position: absolute;
          right: -1.5rem;
          content: "";
          width: 0.75rem;
          height: 1rem;
          background-repeat: no-repeat;
          background-size: 0.75rem 0.75rem;
          background-position: center center;
          background-image: url(#{$assets}/images/icon-active-blue.png);
        }
      }
    }

    .filters {
      width: 360px;
      position: absolute;
      z-index: 1;
      top: 3.375rem;
      background-color: $cc-resmed-white;
      box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.125);

      @media (min-width: 768px) {
        top: 4.5rem;
        transform: translateX(-3.8rem);
      }

      @media (min-width: 992px) {
        top: 3.375rem;
        transform: translateX(0);
      }

      @media (min-width: 1200px) {
        transform: translateX(4.2rem);
      }

      header {
        display: flex;
        justify-content: flex-end;
        padding: 1rem 1.5rem;
        background-color: $cc-resmed-action-red;
        text-align: left;

        h4 {
          flex-grow: 1;
          color: $cc-resmed-white;
          margin: 0;
        }

        a {
          @extend %close-x;
        }
      }

      ul {
        list-style: none;

        &.empty {
          border-bottom: 1px solid $cc-resmed-grey-15;
        }

        li {
          padding: 0;

          background-repeat: no-repeat;
          background-position: 1rem center;
          opacity: 0.5;
          transition: opacity 1s;
          text-align: left;

          &:nth-child(1) {
            background-size: 25px 21px;
            background-image: url(#{$assets}/images/icon-filters-machine.png);
          }
          &:nth-child(2) {
            background-size: 21px 25px;
            background-position: 1.25rem center;
            background-image: url(#{$assets}/images/icon-filters-masks.png);
          }
          &:nth-child(3) {
            background-size: 30px 20px;
            background-position: 0.875rem center;
            background-image: url(#{$assets}/images/icon-filters-travel.png);
          }
          &:nth-child(4) {
            background-size: 27px 18px;
            background-image: url(#{$assets}/images/icon-filters-foam.png);
          }

          &:hover {
            background-color: rgba($cc-resmed-grey-15, 0.6);
          }

          &.is-active {
            background-color: rgba($cc-resmed-grey-15, 0.6);
            opacity: 1;

            a {
              color: $cc-resmed-black;

              background-repeat: no-repeat;
              background-size: 0.75rem 0.75rem;
              background-position: calc(100% - 1.625rem) center;
              background-image: url(#{$assets}/images/icon-active-blue.png);
            }
          }

          a {
            display: block;
            color: $cc-resmed-black;
            padding: 1.125rem 1rem 1.125rem 3.5rem;
          }
        }
      }

      .apply {
        text-align: center;
        margin: 1.5rem auto 2.5rem auto;
      }
    }
  }

  // .applied-filter {
  //     span {
  //         cursor: pointer;
  //         display: inline-block;

  //         background-repeat: no-repeat;
  //         background-position: calc(100% - .5rem) center;
  //         background-size: .875rem .875rem;
  //         background-image: url(#{$assets}/images/icon-applied-filters-x.png);

  //         margin-left: .325rem;
  //         padding-right: 2rem;
  //     }
  // }

  .items {
    display: flex;
    flex-grow: 1;
    flex-basis: 0;
    flex-wrap: wrap;
    margin: 0 -0.5rem;

    .item {
      padding: 0.5rem;
      width: 100%;
      height: 264px;
      background-color: $cc-resmed-white;

      @media (min-width: 768px) {
        width: 33.33333%;
      }

      > a {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.125);
        border-radius: 6px;
        transition: all 0.5s;

        &:hover {
          box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.25);

          img {
            filter: none;
          }
        }

        figure {
          width: 80%;
          margin: 0 auto;

          @media (min-width: 992px) {
            width: 68%;
          }

          img {
            display: block;
            filter: grayscale(100%);
            transition: filter 0.5s;
          }
        }

        .cta {
          a {
            transition: all 0.5s;
          }
        }
      }
    }
  }
}
</style>